import { css } from '@linaria/core';
export const loader = "tils__uiStates_styles_ts-loader-lo2dhkk";
export const errorStateContainer = "tils__uiStates_styles_ts-errorStateContainer-evs7mim";

require("./uiStates.styles.linaria.module.css!=!../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./uiStates.styles.ts");